import { parseAsBoolean, parseAsString, useQueryStates } from '@/libs/nuqs'

const useMemberParams = () => {
	const [params, setParams] = useQueryStates({
		memberId: parseAsString,
		viewMemberId: parseAsString,
		createMember: parseAsBoolean,
		q: parseAsString,
		status: parseAsString,
		sortBy: parseAsString,
		sortDir: parseAsString,
		createTimeOff: parseAsBoolean,
		viewTimeOff: parseAsString,
		toStage: parseAsString,
		toType: parseAsString,
	})

	return { ...params, setParams }
}

export { useMemberParams }
